import React from 'react'
import styled from '@emotion/styled'
import Image from 'src/components/Image'
import TextLink from 'src/components/TextLink'
import TextLockup from "src/components/TextLockup"
import { colors, globals, typography } from 'src/styles'

const CardTitle = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  justify-content: space-between;
  padding: 20px;
  overflow: hidden;
  flex-grow: 1;
  h5 {
    ${typography.articleTitleSmall}
    margin: 0;
  }
  p {
    ${typography.bodySmall}
    color: ${colors.lightTextColor};
    margin: 8px 0 0;
    flex-grow: 1;
  }
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
`

const DirectionsLink = styled(TextLink)`
  margin-top: 14px;
`

const Wrapper = styled(globals.Card)`
  text-align: left;
  display: block;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: flex-start;
  background: ${colors.white};
  .gatsby-image-wrapper,
  .gatsby-image-wrapper img {
    margin: 0;
    border-top-left-radius: ${globals.cardBorderRadius};
    border-top-right-radius: ${globals.cardBorderRadius};
  }
  p {
    ${typography.articleTitleSmall}
    color: ${colors.textColor};
    max-width: 34em;
    margin: 0;
  }
`

const LocationCard = ({ className, item, sizes }) => {
  return (
    <Wrapper className={className}>
      {item?.image?.asset?.gatsbyImageData && (
        <Image
          ratio={2 / 3}
          image={item?.image?.asset?.gatsbyImageData}
          alt={
            item?.image?.altText || item?.title || item?.image?.originalFilename
          }
          sizes={sizes}
        />
      )}
      <CardTitle>
        <h5>{item.title}</h5>
        {item.locationText && <p>{item.locationText}</p>}
        {item._rawTextBox && (
          <TextLockup
            entranceDelay={1}
            text={item._rawTextBox}
            transitionIn={false}
          />
        )}

        {item?.mapLink && (
          <DirectionsLink
            to={item.mapLink}
            external
            target="_blank"
            setTheme="mainColor"
          >
            Directions
          </DirectionsLink>
        )}
      </CardTitle>
    </Wrapper>
  )
}

export default LocationCard
